<template>
    <teleport to="body">
        <Transition>
            <div v-show="catalogModalIsVisible" class="uk-text-center the-modal">
                <div class="the-modal-content the-modal-content-header uk-position-relative">
                    <div class="close-the-modal uk-position-absolute uk-position-small uk-position-top-right" @click="closeCatalogModal">
                        <BaseIcon color="#cdcdcd" height="35" stroke-width=".75" width="35">
                            <IconX />
                        </BaseIcon>
                    </div>
                </div>
                <div class="the-modal-content the-modal-content-body">
                    <div v-if="successMessageIsVisible">
                        <p class="uk-h4 uk-margin-bottom-remove uk-text-success">Request received</p>
                        <p class="uk-margin-remove uk-text-small">Closing popup...</p>
                    </div>
                    <p v-if="formIsVisible" class="uk-h4">Catalog Mailing Address</p>
                    <form v-if="formIsVisible" id="the-form" class="uk-form-stacked uk-text-left uk-text-small" novalidate @submit.prevent="submit">
                        <div class="uk-child-width-1-2 uk-grid-small" uk-grid>
                            <div>
                                <input id="first_name" v-model="form.first_name" :class="{'uk-form-danger': errors?.first_name}" class="uk-input uk-form-small" name="first_name" placeholder="First Name" type="text">
                                <span v-if="errors?.first_name" class="uk-text-small uk-text-danger">{{ errors.first_name[0] }}</span>
                            </div>
                            <div>
                                <input id="last_name" v-model="form.last_name" :class="{'uk-form-danger': errors?.last_name}" class="uk-input uk-form-small" name="last_name" placeholder="Last Name" type="text">
                                <span v-if="errors?.last_name" class="uk-text-small uk-text-danger">{{ errors.last_name[0] }}</span>
                            </div>
                        </div>
                        <div class="uk-margin">
                            <input id="company_name" v-model="form.company_name" :class="{'uk-form-danger': errors?.company_name}" class="uk-input uk-form-small" name="company_name" placeholder="Company Name" type="text">
                            <span v-if="errors?.company_name" class="uk-text-small uk-text-danger">{{ errors.company_name[0] }}</span>
                        </div>
                        <div class="uk-margin">
                            <input id="street_address" v-model="form.street_address" :class="{'uk-form-danger': errors?.street_address}" class="uk-input uk-form-small" name="street_address" placeholder="Street Address" type="text">
                            <span v-if="errors?.street_address" class="uk-text-small uk-text-danger">{{ errors.street_address[0] }}</span>
                        </div>
                        <div class="uk-margin">
                            <input id="city" v-model="form.city" :class="{'uk-form-danger': errors?.city}" class="uk-input uk-form-small" name="city" placeholder="City" type="text">
                            <span v-if="errors?.city" class="uk-text-small uk-text-danger">{{ errors.city[0] }}</span>
                        </div>
                        <div class="uk-margin">
                            <select id="state" v-model="form.state" :class="{'uk-form-danger': errors?.state}" class="uk-select uk-form-small" name="state">
                                <option value=""> -- Select a state --</option>
                                <optgroup label="US">
                                    <option value="AL">Alabama</option>
                                    <option value="AK">Alaska</option>
                                    <option value="AZ">Arizona</option>
                                    <option value="AR">Arkansas</option>
                                    <option value="CA">California</option>
                                    <option value="CO">Colorado</option>
                                    <option value="CT">Connecticut</option>
                                    <option value="DE">Delaware</option>
                                    <option value="DC">District of Columbia</option>
                                    <option value="FL">Florida</option>
                                    <option value="GA">Georgia</option>
                                    <option value="HI">Hawaii</option>
                                    <option value="ID">Idaho</option>
                                    <option value="IL">Illinois</option>
                                    <option value="IN">Indiana</option>
                                    <option value="IA">Iowa</option>
                                    <option value="KS">Kansas</option>
                                    <option value="KY">Kentucky</option>
                                    <option value="LA">Louisiana</option>
                                    <option value="ME">Maine</option>
                                    <option value="MD">Maryland</option>
                                    <option value="MA">Massachusetts</option>
                                    <option value="MI">Michigan</option>
                                    <option value="MN">Minnesota</option>
                                    <option value="MS">Mississippi</option>
                                    <option value="MO">Missouri</option>
                                    <option value="MT">Montana</option>
                                    <option value="NE">Nebraska</option>
                                    <option value="NV">Nevada</option>
                                    <option value="NH">New Hampshire</option>
                                    <option value="NJ">New Jersey</option>
                                    <option value="NM">New Mexico</option>
                                    <option value="NY">New York</option>
                                    <option value="NC">North Carolina</option>
                                    <option value="ND">North Dakota</option>
                                    <option value="OH">Ohio</option>
                                    <option value="OK">Oklahoma</option>
                                    <option value="OR">Oregon</option>
                                    <option value="PA">Pennsylvania</option>
                                    <option value="PR">Puerto Rico</option>
                                    <option value="RI">Rhode Island</option>
                                    <option value="SC">South Carolina</option>
                                    <option value="SD">South Dakota</option>
                                    <option value="TN">Tennessee</option>
                                    <option value="TX">Texas</option>
                                    <option value="UT">Utah</option>
                                    <option value="VT">Vermont</option>
                                    <option value="VA">Virginia</option>
                                    <option value="WA">Washington</option>
                                    <option value="WV">West Virginia</option>
                                    <option value="WI">Wisconsin</option>
                                    <option value="WY">Wyoming</option>
                                </optgroup>
                                <optgroup label="CANADA">
                                    <option value="AB">Alberta</option>
                                    <option value="BC">British Columbia</option>
                                    <option value="MB">Manitoba</option>
                                    <option value="NB">New Brunswick</option>
                                    <option value="NL">Newfoundland and Lab</option>
                                    <option value="NT">Northwest Territorie</option>
                                    <option value="NS">Nova Scotia</option>
                                    <option value="NU">Nunavut</option>
                                    <option value="ON">Ontario</option>
                                    <option value="PE">Prince Edward Island</option>
                                    <option value="QC">Quebec</option>
                                    <option value="SK">Saskatchewan</option>
                                    <option value="YT">Yukon Territory</option>
                                </optgroup>
                                <optgroup label="INTERNATIONAL">
                                    <option value="INTL">Not in US or Canada</option>
                                </optgroup>
                            </select>
                            <span v-if="errors?.state" class="uk-text-small uk-text-danger">{{ errors.state[0] }}</span>
                        </div>
                        <div class="uk-margin">
                            <input id="zip" v-model="form.zip" :class="{'uk-form-danger': errors?.zip}" class="uk-input uk-form-small" name="zip" placeholder="Zip" type="text">
                            <span v-if="errors?.zip" class="uk-text-small uk-text-danger">{{ errors.zip[0] }}</span>
                        </div>
                        <div class="uk-margin">
                            <select id="country" v-model="form.country" :class="{'uk-form-danger': errors?.country}" class="uk-select uk-form-small" name="country">
                                <option value="US">United States</option>
                                <option value="CA">Canada</option>
                            </select>
                            <span v-if="errors?.country" class="uk-text-small uk-text-danger">{{ errors.country[0] }}</span>
                        </div>
                        <div class="uk-flex uk-flex-right">
                            <button :disabled="processing" class="uk-button uk-button-primary">
                                <span v-show="processing" id="submit-button-spinner" uk-spinner></span>
                                <span v-show="!processing" id="submit-button-text">Submit</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Transition>
    </teleport>
</template>

<script setup>
import {reactive, ref} from 'vue'
import {storeToRefs} from "pinia"
import {useModalStatusStore} from '../../stores/ModalStatusStore'
import BaseIcon from '../ui/BaseIcon.vue'
import IconX from '../icons/IconX.vue'

const modalStatusStore = useModalStatusStore()
const errors = ref({})
const successMessageIsVisible = ref(false)
const formIsVisible = ref(true)
const processing = ref(false)

const form = reactive({
    first_name: '',
    last_name: '',
    company_name: '',
    street_address: '',
    city: '',
    state: '',
    zip: '',
    country: 'US'
});

const {
    catalogModalIsVisible
} = storeToRefs(modalStatusStore)

async function submit() {
    processing.value = true
    try {
        await axios.post('/catalog/ajax-store', form)
        successMessageIsVisible.value = true
        formIsVisible.value = false

        setTimeout(function () {
            closeCatalogModal()
        }, 3000);
    } catch (error) {
        if (error.response.status === 422) {
            errors.value = error.response.data.errors
        }
        // DEBUG OUT
        // Utility.catchError(error)
    }
    processing.value = false
}

function closeCatalogModal() {
    modalStatusStore.hideCatalogModal()

    window.location.reload()
}
</script>

<style scoped>
.the-modal {
    position: fixed; /* Stay in place */
    z-index: 99;
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.8); /* w/ opacity */
}

/* Modal Content/Box */
.the-modal-content {
    background-color: #ffffff;
    margin-left: auto;
    margin-right: auto;
    max-width: 345px;
}

.the-modal-content-header {
    margin-top: 15px;
    margin-bottom: 0;
    padding: 10px 30px 10px 30px;
}

.the-modal-content-body {
    margin-top: 0;
    margin-bottom: 0;
    padding: 20px 30px 30px 30px;
}

.close-the-modal {
    cursor: pointer;
}

.v-enter-active,
.v-leave-active {
    transition: opacity 0.75s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
